export default __webpack_public_path__ + "static/media/LOGO_FINANCIERA.dfca39b4.png";